module.exports = __webpack_public_path__ + "img/debg.03b9e85d.jpg";